/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The text to be displayed on web form's submit button.
 *
 * @remarks
 *
 * If set to "auto" the UI will automatically select between
 * "pay" and "confirm" for payments and payouts respectively.
 */
export const CallToAction = {
  Pay: "pay",
  Book: "book",
  Subscribe: "subscribe",
  Donate: "donate",
  Confirm: "confirm",
  Auto: "auto",
} as const;
/**
 * The text to be displayed on web form's submit button.
 *
 * @remarks
 *
 * If set to "auto" the UI will automatically select between
 * "pay" and "confirm" for payments and payouts respectively.
 */
export type CallToAction = ClosedEnum<typeof CallToAction>;

/** @internal */
export const CallToAction$inboundSchema: z.ZodNativeEnum<typeof CallToAction> =
  z.nativeEnum(CallToAction);
/** @internal */
export const CallToAction$outboundSchema: z.ZodNativeEnum<typeof CallToAction> =
  CallToAction$inboundSchema;
